// @ts-nocheck
/**
 * Purabelle Bundle — Shared Core Engine
 * Fil: assets/purabelle-bundle-core.js
 *
 * Den dokumenterede, genbrugte motor bag både PDP-modulet
 * (snippets/purabelle-bundle.liquid) og den standalone bygger-side
 * (sections/purabelle-bundle-builder.liquid).
 *
 * Logikken er løftet 1:1 fra assets/purabelle-bundle.js og gjort ren
 * (uafhængig af modul-state), så begge forbrugere deler ÉN prismotor,
 * lager-/forudbestillingslogik og Horizon-native kurv-tilføjelse.
 *
 * VIGTIGT: Denne fil ÆNDRER ikke PDP-modulet. PDP'en kører uændret.
 */
(function () {
  'use strict';

  // ─── Konfiguration (kilde til sandhed for pris-stigen) ──────────────────────
  // Skal matche Shopifys automatiske mængderabat ("Mængderabet") pr. størrelse.
  //
  // MARKEDS-SIKKER STIGE: stigen er udtrykt som ANDEL af fuld pris — ikke som
  // faste DKK-beløb. Faste beløb var årsagen til at SE/DE fik danske priser
  // (3 x 100ml viste 699 "kr." på det svenske marked i stedet for 1054 SEK).
  // Andelene er afledt 1:1 af den danske stige og reproducerer Shopifys egne
  // markedskonverterede bundle-priser (verificeret mod purabelle.se: 100ml x3
  // -> 1054, 30ml x3 -> 602, 3ml x4 -> 135). Nye markeder virker uden ændringer
  // her, fordi variantpriserne allerede kommer konverteret fra Liquid.
  const CONFIG = {
    // Nødfald hvis siden ikke leverer #pbb-discounts. Den merchant-styrede
    // kilde er theme-indstillingerne ("Purabelle — Mængderabat"); disse tal er
    // kun til for at modulet ikke viser ingenting hvis snippet'en mangler.
    bundleRates: {
      // Andel af fuld pris = 1 − rabatprocenten i "Mængderabet" (Shopify gemmer 2 decimaler).
      '100ml': { 2: 0.8344, 3: 0.7793, 4: 0.6681, 5: 0.6254, 6: 0.6254 },
      // 30 ml ny basis-stige 2026-09-16 (199 kr/stk): 338,98 / 429 / 549 / 668,95 / 789 kr.
      '30ml':  { 2: 0.8517, 3: 0.7186, 4: 0.6897, 5: 0.6723, 6: 0.6608 },
      // 3 ml koster 39 kr: 69 / 99 / 129 / 159 / 189 kr.
      '3ml':   { 2: 0.8847, 3: 0.8462, 4: 0.8270, 5: 0.8155, 6: 0.8078 },
    },
    collections: { herre: 'herre', damer: 'damer' },
  };

  // Rabat-stigen fra theme-indstillingerne, renderet af
  // snippets/purabelle-bundle-discounts.liquid. Læses én gang; falder tilbage
  // til CONFIG hvis den mangler. Procent -> andel af fuld pris.
  let rateTable = null;
  function rates() {
    if (rateTable) return rateTable;
    rateTable = {};
    const node = document.getElementById('pbb-discounts');
    if (node) {
      try {
        JSON.parse(node.textContent).forEach((t) => {
          if (!t || !t.size || !t.qty) return;
          const pct = parseFloat(t.percent);
          if (!isFinite(pct)) return;
          (rateTable[t.size] = rateTable[t.size] || {})[t.qty] = 1 - pct / 100;
        });
      } catch (e) {
        console.warn('Purabelle: kunne ikke parse #pbb-discounts', e);
      }
    }
    if (!Object.keys(rateTable).length) rateTable = CONFIG.bundleRates;
    return rateTable;
  }

  function ratesForSize(size) {
    const all = rates();
    return all[size] || all['100ml'] || CONFIG.bundleRates['100ml'];
  }

  // ─── Pris ───────────────────────────────────────────────────────────────────
  // Aktiv valuta kommer fra Shopify og følger markedet (DKK/SEK/EUR/…).
  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
  }

  // Sproget bestemmer tal- og valutaformat (1.054 kr. vs 1 054 kr vs 1.054,00 €).
  function activeLocale() {
    return document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'da';
  }

  // Markedsbevidst formattering. Ingen hardcodet "kr." — den var forkert på
  // ethvert ikke-dansk marked og direkte misvisende i Tyskland.
  function formatPrice(priceInMinorUnits) {
    const amount = (priceInMinorUnits || 0) / 100;
    try {
      // Decimaler kun når beløbet faktisk har dem: "699 kr." på DKK/SEK, men
      // "95,74 €" på EUR, hvor prispunkterne ender på ,95. Fast 0 decimaler
      // ville skjule cents og vise en pris kunden ikke betaler.
      const fraction = Number.isInteger(amount) ? 0 : 2;
      return new Intl.NumberFormat(activeLocale(), {
        style: 'currency',
        currency: activeCurrency(),
        minimumFractionDigits: fraction,
        maximumFractionDigits: fraction,
      }).format(amount);
    } catch (e) {
      // Ukendt locale/valuta — fald tilbage til et neutralt format frem for at
      // vise et forkert valutasymbol.
      return Math.round(amount).toString() + ' ' + activeCurrency();
    }
  }

  // Hele kroner i visningen på kr-markeder (DKK/SEK): kurven kan vise 498,98, siden viser
  // 499. EUR beholder cent, fordi prispunkterne ender på ,95.
  function displayTotal(minor) {
    return /^(DKK|SEK|NOK)$/.test(activeCurrency()) ? Math.round(minor / 100) * 100 : minor;
  }

  // "Mængderabet" er en procent af hver kurvlinje, og Shopify runder rabatten pr. linje
  // til mindste valutaenhed (øre/cent). Vi regner præcis det samme, så den viste pris er
  // det kurven opkræver på DKK, SEK og EUR. Ingen afrunding til hele kroner: EUR-
  // prispunkterne ender på ,95.
  // `lines`: linjebeløb i minor units (pris × antal pr. kurvlinje).
  // Rabatten pr. linje regnes i heltal (basispoint) og rundes NED til helt øre/cent, som
  // Shopify gør (set i rigtige kurve 2026-09-16: 45 SEK × 17,30 % = 7,785 → 7,78).
  function lineDiscount(line, rate) {
    const bp = Math.round((1 - rate) * 10000);
    return Math.floor((line * bp) / 10000);
  }

  function applyRate(lines, rate) {
    return lines.reduce((sum, line) => sum + line - lineDiscount(line, rate), 0);
  }

  // Én linje pr. flaske til enhedsprisen, medmindre de faktiske kurvlinjer gives.
  // Et tal accepteres stadig som én samlet linje, så ældre kaldere virker uændret.
  function toLines(base, qty, lines) {
    if (Array.isArray(lines) && lines.length) return lines;
    if (typeof lines === 'number') return [lines];
    return Array.from({ length: Math.max(0, qty || 0) }, () => base || 0);
  }

  // Bundle-total (minor units) for en størrelse + antal ud fra den AKTUELLE markedspris.
  function bundleTotal(size, base, qty, lines) {
    const r = ratesForSize(size);
    const l = toLines(base, qty, lines);
    if (qty < 2) return l.reduce((sum, line) => sum + line, 0);
    const rate = r[qty] || r[6] || r[5];
    return applyRate(l, rate);
  }

  // Tier-pris for nøjagtigt N flasker (det kunden betaler i kurven).
  function tierPrice(size, qty, base, lines) {
    const r = ratesForSize(size);
    if (r[qty] == null) return null;
    const l = toLines(base, qty, lines);
    if (!l.some(Boolean)) return null;
    return applyRate(l, r[qty]);
  }

  function perBottle(size, base, qty) {
    if (qty < 1) return base || 0;
    return Math.round(bundleTotal(size, base, qty) / qty);
  }

  // ─── Lager / forudbestilling (1:1 fra PDP-modulet) ──────────────────────────
  function isOutOfStock(inv) {
    if (!inv) return false;
    return inv.variantInventoryManagement === 'shopify' &&
      (inv.variantInventoryQuantity <= 0 || inv.variantQuantityRuleMin > inv.variantInventoryQuantity);
  }

  function isPreorder(inv) {
    if (!inv) return false;
    // State is computed server-side (snippets/preorder-state-fields.liquid). The JS only
    // reads it. Fallback to stock+policy if state is absent. The date NEVER triggers.
    if (inv.state) return inv.state === 'preorder';
    return isOutOfStock(inv) && inv.variantInventoryPolicy === 'continue';
  }

  function isAvailable(inv) {
    return !isOutOfStock(inv);
  }

  // Maks. antal kunden kan vælge af én variant (respekterer lagerstyring).
  function maxQtyForVariant(inv) {
    inv = inv || {};
    const managed = inv.variantInventoryManagement === 'shopify';
    const denies = inv.variantInventoryPolicy !== 'continue';
    if (managed && denies) return Math.max(1, inv.variantInventoryQuantity || 0);
    return 99; // continue-selling / preorder / ustyret
  }

  // ─── Lager-index fra Liquid-injicerede <script> JSON-blokke ─────────────────
  function collectInventory(collectionHandles) {
    let data = [];
    (collectionHandles || Object.keys(CONFIG.collections)).forEach((handle) => {
      const json = document.getElementById(`${handle}-products`);
      if (!json) return;
      try {
        data = data.concat(JSON.parse(json.textContent));
      } catch (e) {
        console.warn(`Purabelle: kunne ikke parse ${handle}-products`, e);
      }
    });
    return data;
  }

  function findProductInventory(invData, productId) {
    return (invData || []).find(i => i.productId == productId);
  }

  function findVariantInventory(invData, productId, variantId) {
    const p = findProductInventory(invData, productId);
    return p ? p.variants.find(v => v.variantId == variantId) : {};
  }

  // ─── Forudbestillings-egenskaber til linje-varer (1:1 fra PDP-modulet) ──────
  function buildPreorderProperties(inv) {
    if (!isPreorder(inv)) return undefined;
    const properties = {};
    if (inv && inv.shipDate) {
      properties['Forudbestilling'] = `Sendes inden ${inv.shipDate}`;
    } else {
      properties['Status'] = 'Forudbestilling';
    }
    return Object.keys(properties).length > 0 ? properties : undefined;
  }

  // ─── Kurv (Horizon-native, ingen reload — 1:1 fra PDP-modulet) ──────────────
  async function addToCart(items) {
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map(el => el.dataset.sectionId)
      .filter(Boolean);
    const uniqueSectionIds = Array.from(new Set(sectionIds));

    const cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

    const res = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items,
        sections: uniqueSectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    if (!res.ok) {
      let description = 'Cart fejl';
      try {
        const err = await res.json();
        description = err.description || err.message || description;
      } catch (e) { /* ignore */ }
      throw new Error(description);
    }
    return res.json();
  }

  // Genrender Horizons kurv-komponenter og åbn skuffen (ingen reload).
  function refreshCartUI(cart, addedCount, sourceProductId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'purabelle-bundle-builder',
        data: {
          source: 'product-form-component',
          itemCount: addedCount,
          productId: sourceProductId || null,
          sections: (cart && cart.sections) || {},
        },
      },
    }));
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  // ─── Offentlig API ──────────────────────────────────────────────────────────
  window.PurabelleBundleCore = {
    CONFIG,
    rates,
    ratesForSize,
    formatPrice,
    displayTotal,
    bundleTotal,
    tierPrice,
    perBottle,
    isOutOfStock,
    isPreorder,
    isAvailable,
    maxQtyForVariant,
    collectInventory,
    findProductInventory,
    findVariantInventory,
    buildPreorderProperties,
    addToCart,
    refreshCartUI,
  };
})();
